import { useEffect, useMemo } from 'react';
import { AiFillCar } from 'react-icons/ai';
import { BsTools } from 'react-icons/bs';
import { FaRegCalendarAlt, FaUsers } from 'react-icons/fa';
import { GiTwoCoins } from 'react-icons/gi';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { IoHome } from 'react-icons/io5';
import { MdAdminPanelSettings, MdOutlineStickyNote2 } from 'react-icons/md';
import { RiAccountCircleFill } from 'react-icons/ri';
import { SiGoogleearthengine, SiHonda } from 'react-icons/si';
import { VscGraph } from 'react-icons/vsc';
import { useLocation } from 'react-router-dom';
import Divider from '../../components/shared/divider/Divider';
import ActionLogo from '../../components/shared/logo/ActionLogo';
import { ROLE_ADMIN } from '../../redux/constants/rolesConstants';
import MenuItem from './MenuItem';
import SideMenu from './SideMenu';

function Index({ userData, showSidebar, setShowSidebar, isTabletView }) {
  const { pathname } = useLocation();
  const isAdmin = userData?.roles.includes(ROLE_ADMIN);
  const iconSize = 20;

  useEffect(() => {
    isTabletView && setShowSidebar(false);
  }, [setShowSidebar, isTabletView, pathname]);

  const homeSubMenu = useMemo(
    () => [
      { title: 'Мій кабінет', icon: <IoHome size={iconSize} />, path: '/' },
      { title: 'Нотатки', icon: <MdOutlineStickyNote2 size={iconSize} />, path: '/notes' },
      { title: 'Календар', icon: <FaRegCalendarAlt size={iconSize} />, path: '/calendar' },
      { title: 'Аналітика', icon: <VscGraph size={iconSize} />, path: '/analytics' },
    ],
    [],
  );

  const partsSubMenu = useMemo(
    () => [
      { title: 'Автомобілі', icon: <AiFillCar size={iconSize} />, path: '/vehicles' },
      { title: 'Послуги', icon: <BsTools size={iconSize} />, path: '/tasks' },
      {
        title: 'Запчастини',
        icon: <SiGoogleearthengine size={iconSize} />,
        path: '/parts',
      },
      {
        title: 'Клієнти',
        icon: <FaUsers size={iconSize} />,
        path: '/clients',
      },
    ],
    [],
  );

  const ratesSubMenu = useMemo(
    () => [
      {
        title: 'Оцінка вартості',
        icon: <GiTwoCoins size={iconSize} />,
        path: '/rates',
      },
      {
        title: 'Марки авто',
        icon: <SiHonda size={iconSize} />,
        path: '/brands',
      },
    ],
    [],
  );

  const adminSubMenu = useMemo(
    () => [
      {
        title: 'Користувачі',
        icon: <MdAdminPanelSettings size={iconSize} />,
        path: '/users',
      },
    ],
    [],
  );

  const profileSubMenu = useMemo(
    () => [
      {
        title: 'Профіль',
        icon: <RiAccountCircleFill size={iconSize} />,
        path: '/profile',
      },
    ],
    [],
  );

  return (
    <SideMenu isTabletView={isTabletView} isOpen={showSidebar} setIsOpen={setShowSidebar}>
      <div className="shrink-0">
        <SidebarLogo setShowSidebar={setShowSidebar} />
        <Divider className="mt-0" />
      </div>
      <div className="menu-scroll flex-1 min-h-0 overflow-y-auto py-0 md:py-2 grid gap-2 md:gap-3 mt-2 content-start">
        {homeSubMenu.map((item, index) => {
          return <MenuItem key={index} title={item.title} icon={item.icon} path={item.path} />;
        })}
        <Divider />
        {partsSubMenu.map((item, index) => {
          return <MenuItem key={index} title={item.title} icon={item.icon} path={item.path} />;
        })}
        <Divider />
        {ratesSubMenu.map((item, index) => {
          return <MenuItem key={index} title={item.title} icon={item.icon} path={item.path} />;
        })}
        <Divider />
        {isAdmin && (
          <>
            {adminSubMenu.map((item, index) => {
              return <MenuItem key={index} title={item.title} icon={item.icon} path={item.path} />;
            })}
            <Divider />
          </>
        )}
        {profileSubMenu.map((item, index) => {
          return <MenuItem key={index} title={item.title} icon={item.icon} path={item.path} />;
        })}
      </div>
    </SideMenu>
  );
}

const SidebarLogo = ({ setShowSidebar }) => (
  <div className="flex p-4 bg-bg1">
    <button
      onClick={() => setShowSidebar(false)}
      className="flex lg:hidden items-center p-2 mr-3 rounded-xl hover:bg-bg4 duration-300"
    >
      <IoMdArrowRoundBack size={24} className="text-font1" />
    </button>
    <ActionLogo isDark={false} />
  </div>
);

export default Index;
